import React from 'react';
import { ReactNode } from "react";
import { Helmet } from "react-helmet-async";


import InsuranceCarriersList_v01 from './InsuranceCarriersList_v01';
import NavBar_v03Responsive from '../component-library/NavBar_v03a_Responsive_component';
import Carousel_v06_basic from '../component-library/Carousel_v06_Basic_Component';
import Features_v03_Links_AccordianHeadLine_JULY2025  from './Features_accordian_v03_Links_WithHeadline_JULY2025_component';

import RowOptionList from '../component-library/RowOptionList_v01_component';
import RowOptionImageList from '../component-library/RowOptionImageList_v01_component';

import { IBusinessServicesList, IBusinessService }from '../component-library/RowOptionList_v01_component';


import MetricsRow_v01 from '../component-library/MetricsRow4Columns_v01_component';
import './HomePage_v02_TwoRows_LegacyInsurance.css'

import { IAppConfig } from "../App_v01_Interfaces";
// import Features_v02_Links_Accordian from '../component-library/Features_accordian_v02_Links_component';
import Features_v03_Links_AccordianHeadLine from '../component-library/Features_accordian_v03_Links_WithHeadline_component';


interface AppConfigProps{
  appConfig: IAppConfig;
}//end:


const HomePage_LegacyInsurance: React.FC<AppConfigProps> = ({appConfig}) => {
  
  return (
      <>
        <div className='container-fluid mt-0 my-homePage'>
          {/* <NavBar_v03Responsive appConfig={appConfig} /> */}

          <Carousel_v06_basic items={appConfig.homePageCarouselItems}></Carousel_v06_basic>
                   
          {/* <Features_v01CategoriesAccordian appFeatures={appConfig.homePageFeaturesList}></Features_v01CategoriesAccordian> */}
         

          
          <Features_v03_Links_AccordianHeadLine_JULY2025 appFeatures={appConfig.homePageFeaturesList}></Features_v03_Links_AccordianHeadLine_JULY2025>


          <InsuranceCarriersList_v01></InsuranceCarriersList_v01>

         
          <MetricsRow_v01 metricsRowData={appConfig.homePageMetrics} cssValue={appConfig.HomePageMetrcsCSSValue}></MetricsRow_v01>  

            {/* <!-- Personal Insurance Section --> */}
         
         
         
            {/* 

          <RowOptionImageList bizServicesList={appConfig.ServicesPage1}></RowOptionImageList>
          <RowOptionList bizServicesList={appConfig.ServicesPage2}></RowOptionList>


            <section id="personal" className="py-5 hover-card">
              <div className="container">
                <h2 className="text-center mb-4">Personal Insurance</h2>
                <div className="row text-center">
                  <div className="col-md-4">
                    <a href="personal-insurance.html" className="text-decoration-none text-dark">
                      <i className="bi bi-house-door-fill fs-1 text-primary"></i>
                      <h4>Homeowners Insurance</h4>
                      <p>Protect your home and belongings from theft, fire, and natural disasters.</p>
                    </a>
                  </div>
                  <div className="col-md-4">
                    <a href="personal-insurance.html" className="text-decoration-none text-dark">
                      <i className="bi bi-car-front-fill fs-1 text-primary"></i>
                      <h4>Auto Insurance</h4>
                      <p>Coverage for your car, truck, or SUV including liability, collision, and more.</p>
                    </a>
                  </div>
                  <div className="col-md-4">
                    <a href="personal-insurance.html" className="text-decoration-none text-dark">
                      <i className="bi bi-heart-pulse-fill fs-1 text-primary"></i>
                      <h4>Life & Health</h4>
                      <p>Secure peace of mind with term life, whole life, and health insurance plans.</p>
                    </a>
                  </div>
                </div>
              </div>
            </section> 
            
            */}

              {/* <!-- Business Insurance Section --> */}
              
              {/* 
              <section id="business" className="py-5 hover-card">
                <div className="container-fluid">
                  <h2 className="text-center mb-4">Business Insurance</h2>
                
                  <div className="row text-center">
                
                    <div className="col-md-2">
                      <a href="business-insurance.html" className="text-decoration-none text-dark">
                        <i className="bi bi-building-fill fs-1 text-dark"></i>
                        <h4>General Liability</h4>
                        <p>Protect your company from lawsuits, injury claims, and third-party damages.</p>
                      </a>
                    </div>
                
                
                    <div className="col-md-2">
                      <a href="business-insurance.html" className="text-decoration-none text-dark">
                        <i className="bi bi-tools fs-1 text-dark"></i>
                        <h4>Commercial Property</h4>
                        <p>Safeguard your buildings, inventory, and equipment from unexpected losses.</p>
                      </a>
                    </div>
                
                
                    <div className="col-md-2">
                      <a href="business-insurance.html" className="text-decoration-none text-dark">
                        <i className="bi bi-briefcase-fill fs-1 text-dark"></i>
                        <h4>Workers’ Compensation</h4>
                        <p>Care for your employees and stay compliant with state laws and regulations.</p>
                      </a>
                    </div>
                
                

                    <div className="col-md-2">
                      <a href="business-insurance.html" className="text-decoration-none text-dark">
                        <i className="bi bi-building-fill fs-1 text-dark"></i>
                        <h4>General Liability</h4>
                        <p>Protect your company from lawsuits, injury claims, and third-party damages.</p>
                      </a>
                    </div>
                
                
                    <div className="col-md-2">
                      <a href="business-insurance.html" className="text-decoration-none text-dark">
                        <i className="bi bi-tools fs-1 text-dark"></i>
                        <h4>Commercial Property</h4>
                        <p>Safeguard your buildings, inventory, and equipment from unexpected losses.</p>
                      </a>
                    </div>
                
                
                    <div className="col-md-2">
                      <a href="business-insurance.html" className="text-decoration-none text-dark">
                        <i className="bi bi-briefcase-fill fs-1 text-dark"></i>
                        <h4>Workers’ Compensation</h4>
                        <p>Care for your employees and stay compliant with state laws and regulations.</p>
                      </a>
                    </div>
                
                  </div>
                </div>
              </section> 
              */}




          
        </div>
      </>
  );
};



export default HomePage_LegacyInsurance;



// import { homePage_01_carouselItems_DATA, homePage_02_FeatureList_DATA, homePage_03_metricsRow_DATA } from "./App_v01_LegacyInsurance_ConfigData";

// const Header: React.FC = () => (
//   <header>
//     <div className="navbar navbar-dark bg-dark box-shadow">
//       <div className="container d-flex justify-content-between">
//         <a href="#" className="navbar-brand d-flex align-items-center">
//           <strong>Album</strong>
//         </a>
//       </div>
//     </div>
//   </header>
// );

// const Jumbotron: React.FC = () => (
//   <section className="jumbotron text-center">
//     <div className="container">
//       <h1 className="jumbotron-heading">Album example</h1>
//       <p className="lead text-muted">
//         Something short and leading about the collection below—its contents,
//         the creator, etc. Make it short and sweet, but not too short so folks
//         don’t simply skip over it entirely.
//       </p>
//       <p>
//         <a href="#" className="btn btn-primary my-2">
//           Main call to action
//         </a>
//         <a href="#" className="btn btn-secondary my-2 ml-2">
//           Secondary action
//         </a>
//       </p>
//     </div>
//   </section>
// );

// const Footer: React.FC = () => (
//   <footer className="text-muted">
//     <div className="container">
//       <p className="float-right">
//         <a href="#">Back to top</a>
//       </p>
//       <p>
//         Album example is &copy; Bootstrap, but please download and customize it
//         for yourself!
//       </p>
//       <p>
//         New to Bootstrap?{" "}
//         <a href="https://getbootstrap.com/">Visit the homepage</a>.
//       </p>
//     </div>
//   </footer>
// );




// import Features_v01 from '../component-demos/Features_v01';

// import HalfImageHalfText from '../component-demos/HalfImageHaflText_v01';
// import { IMetricsRowData } from "../App_v01_Interfaces";
// import { IFeatureList, IFeature, IFeatureFact } from '../App_v01_Interfaces';



// import Carousel_v01 from '../component-demos/Carousel_v01';
// import Carousel_v02 from '../component-demos/Carousel_v02';
// import Carousel_v03 from '../component-demos/Carousel_v03';
// import Carousel_v05 from '../component-demos/Carousel_v05';
// import Carousel_v07_responsive from "../component-demos/Carousel_v07_responsive";

// const imageData = [
//   { src: "https://placehold.co/600x400", caption: "Caption for Image 1" },
//   { src: "https://placehold.co/600x401", caption: "Caption for Image 2" },
//   { src: "https://placehold.co/600x402", caption: "Caption for Image 3" },
//   // { src: "https://placehold.co/600x404", caption: "Caption for Image 4" },
// ];






// interface FeatureListProps{
//   appFeatures: IFeatureList;
// }//end:

// interface MetricsRowDataProps{
//   metricsRowData: IMetricsRowData;
// }//end:




// interface CardProps {
//   index: number;
// }

// const Card: React.FC<CardProps> = ({ index }) => (
//   <div className="col-md-4">
//     <div className="card mb-4 box-shadow rounded-lg">
//       <svg
//         className="bd-placeholder-img card-img-top"
//         width="100%"
//         height="225"
//         xmlns="http://www.w3.org/2000/svg"
//         preserveAspectRatio="xMidYMid slice"
//         role="img"
//         aria-label={`Placeholder: Thumbnail ${index}`}
//       >
//         <title>Placeholder</title>
//         <rect width="100%" height="100%" fill="#55595c" />
//         <text x="50%" y="50%" fill="#eceeef" dy=".3em" textAnchor="middle">
//           Thumbnail {index}
//         </text>
//       </svg>
//       <div className="card-body">
//         <p className="card-text">
//           This is a wider card with supporting text below as a natural lead-in
//           to additional content. This content is a little bit longer.
//         </p>
//         <div className="d-flex justify-content-between align-items-center">
//           <div className="btn-group">
//             <button type="button" className="btn btn-sm btn-outline-secondary">
//               View
//             </button>
//             <button type="button" className="btn btn-sm btn-outline-secondary">
//               Edit
//             </button>
//           </div>
//           <small className="text-muted">9 mins</small>
//         </div>
//       </div>
//     </div>
//   </div>
// );

// const Album: React.FC = () => (
//   <div className="album py-5 bg-light">
//     <div className="container">
//       <div className="row">
//         {Array.from({ length: 9 }, (_, i) => (
//           <Card key={i} index={i + 1} />
//         ))}
//       </div>
//     </div>
//   </div>
// );

// const App: React.FC = () => (
//   <>
//     <Header />
//       <main role="main">
//         <Jumbotron />
//         <Album />
//       </main>
//     <Footer />
//   </>
// );

